import axios from 'axios';

const TRACKING_API_URL = `${process.env.REACT_APP_API_URL}/track`;

export const trackEvent = async (event) => {
    const timestamp = new Date().toISOString();
    const token = localStorage.getItem('token');

    try {
        await axios.post(TRACKING_API_URL, { event, timestamp }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    } catch (error) {
        //console.error('Error tracking event:', error);
    }
};
